import { Cell, Grid } from 'bold-ui'
import { FormSectionAccordion } from 'components/accordion/FormSectionAccordion'
import { RadioGroupField, SelectField, SimNaoRadioGroupField } from 'components/form'
import { CheckboxGroupField } from 'components/form/field/CheckboxGroupField'
import { RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'
import metaPath from 'util/metaPath/metaPath'

import { RASTREIO_CANCER_OPCAO_LABEL } from '../../model-rastreioCancer'
import { RequisicaoExameMamografiaFormValues } from '../model-mamografia'
import { MamografiaIndicacaoClinicaAccordionProps } from './MamografiaIndicacaoClinicaAccordion'
import {
  descargaPapilarOptions,
  linfonodoPalpavelOptions,
  noduloEspessamentoComboboxItems,
} from './model-indicacaoClinica'

const meta = metaPath<RequisicaoExameMamografiaFormValues>()

type MamografiaIndicacaoClinicaMamaAccordionNames = {
  lesaoPapilar: string
  descargaPapilar: string
  noduloLocalizacao: string
  espessamentoLocalizacao: string
  linfonodoPalpavel: string
}

interface MamografiaIndicacaoClinicaMamaAccordionProps
  extends Omit<MamografiaIndicacaoClinicaAccordionProps, 'options'> {
  names: MamografiaIndicacaoClinicaMamaAccordionNames
}

export function MamografiaIndicacaoClinicaMamaAccordion(props: Readonly<MamografiaIndicacaoClinicaMamaAccordionProps>) {
  const { names, title, uuid } = props

  const styles = createStyles()

  const itemToString = (item: RastreioCancerPerguntaOpcaoEnum) => RASTREIO_CANCER_OPCAO_LABEL[item]

  return (
    <FormSectionAccordion name={meta.openedAccordions} title={title} uuid={uuid} style={styles.accordion}>
      <Grid style={styles.container}>
        <Cell size={12}>
          <SimNaoRadioGroupField name={names.lesaoPapilar} label='Lesão papilar' clearable />
        </Cell>
        <Cell size={12}>
          <RadioGroupField
            name={names.descargaPapilar}
            label='Descarga papilar espontânea'
            options={descargaPapilarOptions}
            clearable
          />
        </Cell>
        <Cell size={6}>
          <SelectField
            name={names.noduloLocalizacao}
            label='Nódulo - localização'
            items={noduloEspessamentoComboboxItems}
            itemToString={itemToString}
            multiple
          />
        </Cell>
        <Cell size={6}>
          <SelectField
            name={names.espessamentoLocalizacao}
            label='Espessamento - localização'
            items={noduloEspessamentoComboboxItems}
            itemToString={itemToString}
            multiple
          />
        </Cell>
        <Cell size={12}>
          <CheckboxGroupField
            name={names.linfonodoPalpavel}
            label='Linfonodo palpável'
            options={linfonodoPalpavelOptions}
          />
        </Cell>
      </Grid>
    </FormSectionAccordion>
  )
}

const createStyles = () => ({
  accordion: {
    marginTop: '0.25rem',
    marginBottom: '0.25rem',
  },
  container: {
    padding: '1rem',
  },
})
